module.exports = __webpack_public_path__ + "static/media/image_5.f45f796d.jpg";